// Code generated by balancegen from the [identity.*] nouns of
// data/locale/<tag>/identity.toml and data/contracts/chronicle.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// The noun table of the season chronicle (chronicle.md §9.1, R1176). A
// `noun` param carries the English catalog noun; the book sends it through
// chronicleNoun. The table holds a building, a tech node, a branch and a
// rank title, because only these reach a noun param. English is the
// source language and has no table: its noun is the English noun.

import { LOCALE, type Locale } from './strings.load';

/** The chronicle nouns of each second language, keyed by the English
 *  noun. A noun that reads the same in both languages has no row. */
export const CHRONICLE_NOUNS: Readonly<Partial<Record<Locale, Readonly<Record<string, string>>>>> = {
  de: {
    'Academy': 'Akademie',
    'Acoustics': 'Akustik',
    'Admiral of the Deep': 'Admiral der Tiefe',
    'Aegis Lattice': 'Aegis-Gitter',
    'Alloy Mine': 'Legierungsmine',
    'Anechoic Coatings': 'Schalldämpfende Beschichtungen',
    'Ballistics Principles': 'Ballistische Grundlagen',
    'Biomass Farm': 'Biomassefarm',
    'Brig': 'Arrest',
    'Broad Pennant': 'Breitwimpel',
    'Capital Doctrine': 'Großkampfdoktrin',
    'Captain of the Line': 'Linienkapitän',
    'Cavitation Control': 'Kavitationskontrolle',
    'Command Centre': 'Kommandozentrale',
    'Commander': 'Kommandant',
    'Coxswain': 'Bootsführer',
    'Cryptolinguistics': 'Kryptolinguistik',
    'Damage Control Doctrine': 'Schadensabwehrdoktrin',
    'Deckhand': 'Decksmann',
    'Decoys': 'Täuschmittel',
    'Deep Engineering': 'Tiefseetechnik',
    'Deep Mining': 'Tiefenabbau',
    'Deep Run': 'Tieffahrt',
    'Deep Scan Protocols': 'Tiefenscan-Protokolle',
    'Deep Warden': 'Tiefenwächter',
    'Dive Control': 'Tauchleitstand',
    'Drifter': 'Herumtreiber',
    'Drive Tuning': 'Antriebsabstimmung',
    'Field Repairs': 'Feldreparaturen',
    'Fire Control Uplink': 'Feuerleit-Uplink',
    'Fleet Command': 'Flottenkommando',
    'Fleet Sentinel': 'Flottenwächter',
    'Flotilla Leader': 'Flottillenführer',
    'Foundations': 'Fundamente',
    'Foundry Charter': 'Gießerei-Charta',
    'Frigate Commander': 'Fregattenkapitän',
    'Heavy Industry': 'Schwerindustrie',
    'Heavy Ordnance': 'Schwere Geschütze',
    'Hero of the Trench': 'Held des Grabens',
    'Hull Reinforcement': 'Rumpfverstärkung',
    'Hydrophone Arrays': 'Hydrofon-Arrays',
    'Industry': 'Industrie',
    'Integrated Systems': 'Integrierte Systeme',
    'Legend of the Trench': 'Legende des Grabens',
    'Letters of Marque': 'Kaperbriefe',
    'Lieutenant': 'Leutnant',
    'Lieutenant Commander': 'Korvettenkapitän',
    'Maintenance Corps': 'Instandsetzungskorps',
    'Master of the Abyss': 'Meister des Abgrunds',
    'Point Defence': 'Nahbereichsabwehr',
    'Reclaimed Archives': 'Geborgene Archive',
    'Recruiting Office': 'Anwerbebüro',
    'Research Lab': 'Forschungslabor',
    'Resilience': 'Widerstandskraft',
    'Salvage Rigs': 'Bergungsgeschirr',
    'Sentinel Refit': 'Sentinel-Umbau',
    'Shield Harmonics': 'Schildharmonik',
    'Shield Restoration': 'Schild-Wiederherstellung',
    'Ship Design': 'Schiffsentwurf',
    'Shipyard': 'Werft',
    'Sickbay': 'Krankenrevier',
    'Signal Station': 'Signalstation',
    'Signature Masking': 'Signaturmaskierung',
    'Silent Running': 'Schleichfahrt',
    'Sonar Station': 'Sonarstation',
    'Squadron Master': 'Geschwadermeister',
    'Standard Protocols': 'Standardprotokolle',
    'Storage': 'Lager',
    'Terror of the Depths': 'Schrecken der Tiefe',
    'Torpedo Battery': 'Torpedobatterie',
    'Towed Arrays': 'Schleppantennen',
    'Trade Compacts': 'Handelspakte',
    'Vice Admiral': 'Vizeadmiral',
    'Volatiles Extractor': 'Volatile-Extraktor',
    'Warfare': 'Kriegführung',
    'Warhead Chemistry': 'Sprengkopfchemie',
    'Works Yard': 'Werkhof',
  },
};

const PICKED: Readonly<Record<string, string>> = CHRONICLE_NOUNS[LOCALE] ?? {};

/** The noun of the picked language (LOCALE). A noun with no row keeps
 *  its English form. */
export function chronicleNoun(english: string): string {
  return Object.prototype.hasOwnProperty.call(PICKED, english) ? PICKED[english] : english;
}
